import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ContextDataDisplay from 'Views/Onboarding/Components/ContextDataDisplay';
import { useSurveyStepContext } from './SurveyStepContext';

const styles = () => ({
  root: {},
});

const SurveyStepContextDataDisplay = ({
  className,
  classes,
}) => {
  const contextValue = useSurveyStepContext();

  return (
    <ContextDataDisplay
      className={classNames(classes.root, className)}
      title={'SurveyStepContext'}
      contextValue={contextValue}
    />
  );
};

SurveyStepContextDataDisplay.defaultProps = {
  className: '',
};

SurveyStepContextDataDisplay.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyStepContextDataDisplay);
